import { createRouter, createWebHistory } from 'vue-router'
import { createToaster } from "@meforma/vue-toaster";
import SingIn from '../components/SingIn.vue'
import DropZone from '../components/DropZone.vue'
import con from '../utils/db'
import keys from '../../oauth2.keys.json'

const toaster = createToaster({
  position: "top-right",
  duration: 5000
});
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: SingIn
  },
  {
    path: '/',
    name: 'Principal',
    component: DropZone
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const db = await con.created()
  const isAuthorized = {
    "valid":false,
    "status":"init"
  };

  let key
  if(to.query.code && to.name === 'Login'){
    await con.auth(keys.web.token_uri, {
      "code":to.query.code,
      "client_id":keys.web.client_id,
      "client_secret": keys.web.client_secret,
      "redirect_uri": keys.web.redirect_uris[0],
      "grant_type": "authorization_code"
    }).then(async (data)=>{
      if(data !== undefined){
        const db = await con.created()
        data.type = 'google';
        key = await con.addKeys(db.db, data)
      }
    })
  }
  
  key = key === undefined ? await con.getKeyFromDb(db.db): key
  if(key!== undefined){
    let rpta = await con.checkToken(key)
    if(rpta !== undefined){
      isAuthorized.valid = rpta.valid;
      isAuthorized.status =  rpta.status;
    }
  }else{
    isAuthorized.valid = await con.MSAcquireTokenSilent();
  }
  
  if(!isAuthorized.valid && to.name !== 'Login'){
    return { name: 'Login' }
  }else if(isAuthorized.valid && to.name === 'Login'){
    return { name: 'Principal' }
  }else if(isAuthorized.status == 'bad' && key !== undefined && to.name === 'Login'){
    await con.deleteKey(db.db, key.id_token);
    toaster.error("Cuenta de empresa no valida, por favor verifiquela");
  }
});
export default router
